import { FileText, Globe, Mail, Settings, Shovel, Users, UsersRound } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/use-auth";

const valuerCards = [
  { title: "All Insurance Records", description: "Search and browse all records", href: "/insurance", icon: FileText },
];

const adminCards = [
  { title: "All Insurance Records", description: "Search and browse all records", href: "/insurance", icon: FileText },
  { title: "Property Types", description: "Edit property type classifications", href: "/settings", icon: Globe },
  { title: "Subsoil Options", description: "Edit subsoil list", href: "/settings/subsoil-options", icon: Shovel },
  { title: "Valuers", description: "Manage valuers and signatures", href: "/settings/valuers", icon: Users },
  { title: "Bulk Communications", description: "Send emails to target audiences", href: "/comms", icon: Mail },
  {
    title: "Target Audiences",
    description: "Manage email recipient groups",
    href: "/comms/audiences",
    icon: UsersRound,
  },
  {
    title: "Settings",
    description: "Global defaults, inflation metrics, users",
    href: "/settings/defaults",
    icon: Settings,
  },
];

export function AdminMenu(): React.ReactElement {
  const { user } = useAuth();
  const cards = user?.role === "ADMIN" ? adminCards : valuerCards;

  return (
    <div>
      <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2">Quick Links</h2>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((card) => (
          <Link
            key={card.href}
            to={card.href}
            className="group flex items-center gap-2.5 rounded-md border bg-card px-3 py-2 hover:border-primary/30 hover:bg-accent/30 transition-all"
            data-testid={`admin-card-${card.title.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <card.icon className="h-4 w-4 text-muted-foreground group-hover:text-primary shrink-0" />
            <div className="min-w-0">
              <p className="text-sm font-medium group-hover:text-primary truncate">{card.title}</p>
              <p className="text-xs text-muted-foreground truncate">{card.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
